import actions from '@/store/collections/actions';

const collectionsModule = {
  state: () => ({
    collections: [],
    companyCollections: [],
    collection: {},
    collectionsPages: [],
    isLoading: false,
    isLoadingCollection: false,
    error: null,
  }),
  mutations: {
    GET_COLLECTIONS_START(state) {
      state.isLoading = true;
      state.error = null;
    },
    GET_COLLECTIONS_SUCCESS(state, data) {
      state.collections = data?.map((item) => ({
        ...item,
        products: item?.products?.sort((a, b) => a.index - b.index) || [],
      })) || [];
      state.isLoading = false;
      state.error = null;
    },
    GET_COLLECTIONS_FAILURE(state, data) {
      state.isLoading = false;
      state.error = data;
    },
    GET_COLLECTION_DETAILS_START(state) {
      state.isLoadingCollection = true;
    },
    GET_COLLECTION_DETAILS_SUCCESS(state, data) {
      state.collection = {
        ...data,
        products: data?.products?.sort((a, b) => a.index - b.index) || [],
      };
      state.isLoadingCollection = false;
    },
    GET_COLLECTION_DETAILS_FAILURE(state) {
      state.isLoadingCollection = false;
    },
    GET_COLLECTIONS_PAGES_SUCCESS(state, data) {
      state.collectionsPages = data.keys;
    },
    GET_COMPANY_COLLECTIONS_SUCCESS(state, data) {
      state.companyCollections = data?.map((item) => ({
        ...item,
        products: item?.products?.sort((a, b) => a.index - b.index) || [],
      })) || [];
      state.isLoading = false;
      state.error = null;
    },
  },
  actions,
  namespaced: true,
};

export default collectionsModule;
